import { distance } from "ol/coordinate";
import { coordinatesToEpsg2056, fromEPSG4326 } from "./proj";

export function* pairwise<Type>(iterable: Type[]): Generator<[Type, Type], void> {
  const iterator = iterable.values();
  let previous = iterator.next();
  if (previous.done) {
    return;
  }
  let current = iterator.next();
  while (!current.done) {
    yield [previous.value, current.value];
    previous = current;
    current = iterator.next();
  }
}

export function* enumerate<Type>(iterable: Type[], start = 0): Generator<readonly [number, Type], void> {
  let i = start;
  for (const item of iterable) {
    yield [i++, item] as const;
  }
}

export function indexToLabel(index: number): string {
  return String.fromCharCode(65 + index - 1);
}

/**
 * This function does not return the closest vertex to the given point, but the first one that
 * is within the threshold distance. In this way, it handles the "balloon tour" case where the
 * user returns to the starting point using the same path.
 */
export function findOptimalVertexIndex(line: number[][], point: number[], thresholdMeters = 1.0): number {
  const epsg2056Line: number[][] = coordinatesToEpsg2056(line);
  const epsg2056Point: number[] = fromEPSG4326(point);
  const distances: number[] = [];
  for (const p of epsg2056Line) {
    distances.push(distance(p, epsg2056Point));
  }
  const min_dist = Math.min(...distances);
  const indexes = distances.map((d, i) => (d - min_dist < thresholdMeters ? i : -1)).filter((i) => i !== -1);
  return indexes[0];
}
